"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareJsonFetchArguments = exports.prepareFetchArguments = void 0;
/**
 * @file Prepares fetch arguments for fetching.
 */

const defaults_1 = require("./defaults");

const types_1 = require("./types");

function extractQueryFromOptions(options) {
  const optionsWithQuery = options.filter(x => !!x.query);
  const queryHashes = optionsWithQuery.map(x => x.query);
  return queryHashes.filter(x => !!x);
}

function generateQueryParam(queryHash) {
  const queryFragments = [];
  Object.entries(queryHash).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      const encodedValue = encodeURIComponent(value.toString());
      queryFragments.push([key, encodedValue].join('='));
    }
  });
  return queryFragments.join('&');
}

function appendQueryStringToUrl(url, queryParam) {
  let joinWith = '?';

  if (url.endsWith('?')) {
    joinWith = '';
  } else if (url.includes('?')) {
    joinWith = '&';
  }

  return [url, queryParam].join(joinWith);
}

function extractHeadersFromOptions(options) {
  const optionsWithHeaders = options.filter(x => !!x.headers);
  const headers = optionsWithHeaders.map(x => x.headers);
  return headers.filter(x => !!x);
}

function setHeader(headerHash, newHeaderName, newHeaderValue) {
  if (!headerHash[newHeaderName]) {
    const lowerCaseNewHeaderName = newHeaderName.toLowerCase();
    const headerKeys = Object.keys(headerHash);
    const lowerCaseHeaderKeys = headerKeys.map(x => x.toLocaleLowerCase());
    const index = lowerCaseHeaderKeys.indexOf(lowerCaseNewHeaderName);

    if (index >= 0) {
      delete headerHash[headerKeys[index]];
    }
  }

  headerHash[newHeaderName] = newHeaderValue;
  return headerHash;
}

function mergeHeaders(...args) {
  const allHeaders = {};

  for (const headerHash of args) {
    for (const _ref of Object.entries(headerHash)) {
      var _ref2 = _slicedToArray(_ref, 2);

      const key = _ref2[0];
      const value = _ref2[1];
      setHeader(allHeaders, key, value);
    }
  }

  return allHeaders;
}

function prepareJsonFetchArguments(options) {
  return [(0, defaults_1.getDefaultJsonOptions)()].concat(options);
}

exports.prepareJsonFetchArguments = prepareJsonFetchArguments;

function prepareFetchArguments(url, options) {
  const allOptions = [(0, defaults_1.getDefaultOptions)()].concat(options);
  const fetchOptions = Object.assign({}, ...allOptions);
  const optionsHeaders = extractHeadersFromOptions(allOptions);
  fetchOptions.headers = mergeHeaders(...optionsHeaders);
  let fetchUrl = url; // Append query options to the url itself

  if (fetchOptions.query) {
    const optionQueries = extractQueryFromOptions(allOptions);
    fetchOptions.query = Object.assign({}, ...optionQueries);
    const queryParam = generateQueryParam(fetchOptions.query);
    fetchUrl = appendQueryStringToUrl(url, queryParam);
    delete fetchOptions.query;
  }

  if (fetchOptions.jsonData) {
    fetchOptions.body = JSON.stringify(fetchOptions.jsonData);
    setHeader(fetchOptions.headers, types_1.HTTPHeader.contentType, types_1.HTTPContentType.json);
    delete fetchOptions.jsonData;
  }

  if (fetchOptions.contentType) {
    setHeader(fetchOptions.headers, types_1.HTTPHeader.contentType, fetchOptions.contentType);
    delete fetchOptions.contentType;
  }

  if (fetchOptions.authorization) {
    const _fetchOptions$authori = _slicedToArray(fetchOptions.authorization, 2),
          authScheme = _fetchOptions$authori[0],
          credentials = _fetchOptions$authori[1];

    setHeader(fetchOptions.headers, types_1.HTTPHeader.authorization, `${authScheme} ${credentials}`);
    delete fetchOptions.authorization;
  }

  if (fetchOptions.csrfToken) {
    setHeader(fetchOptions.headers, types_1.HTTPHeader.csrfToken, fetchOptions.csrfToken);
    delete fetchOptions.csrfToken;
  }

  if (fetchOptions.cookies === true) {
    fetchOptions.credentials = types_1.FetchOptionCredentials.include;
    delete fetchOptions.cookies;
  } else if (fetchOptions.cookies === false) {
    fetchOptions.credentials = types_1.FetchOptionCredentials.omit;
    delete fetchOptions.cookies;
  }

  if (fetchOptions.cors === true) {
    fetchOptions.mode = types_1.FetchOptionMode.cors;
    delete fetchOptions.cors;
  } else if (fetchOptions.cors === false) {
    fetchOptions.mode = types_1.FetchOptionMode.noCors;
    delete fetchOptions.cors;
  }

  return [fetchUrl, fetchOptions];
}

exports.prepareFetchArguments = prepareFetchArguments;